<div kendoTooltip showOn="none" [tooltipTemplate]="tooltiptemplate" filter=".k-grid td" (mouseover)="showTooltip($event)">
  <div class="pager-wrapper" *ngIf="reportLoaded && dataSource.data.length > 0">    
        <kendo-pager [skip]="skip"
                     [pageSize]="pageSize"
                     [pageSizeValues]="false"
                     [total]="dataSource.total"
                     [buttonCount]="5"
                     (pageChange)="onPageChange($event)">
        </kendo-pager>
  </div>
    <kendo-grid #kendoGridInstance [data]="dataSource" scrollable="scrollable" [sortable]="true" [sort]="sort" (sortChange)="sortChange($event)" [resizable]="true" class="greyed-report-grid border-top border-bottom border-dark" *ngIf="reportLoaded && dataSource.data.length > 0">


      <kendo-grid-column *ngFor="let item of columns" [ngClass]="{'prewrap' : item.title == 'Training Title'}" [field]="item.field" [minResizableWidth]="80" [title]="item.title" [sortable]="!item.PreventSorting" [filterable]="false" [width]="((item.field === 'Response' && reportName === 'RAIQuestionsResponsesReport') || (item.field === 'DistributionComments' && (reportName === 'SafetyReportsCompletionDetailReport' || reportName === 'EnterpriseSafetyReportsCompletionDetailReport'))) ? 300 : 100">
        <!--[locked]="item.title == 'First Name' || item.title == 'Last Name'"-->
        <ng-template kendoGridCellTemplate let-dataItem let-field="field">
          <div *ngIf="((item.field === 'Response' && reportName === 'RAIQuestionsResponsesReport') || (item.field === 'Comment' && (reportName === 'SafetyReportsCompletionDetailReport' || reportName === 'EnterpriseSafetyReportsCompletionDetailReport'))); else normalCell"
               class="scrollable-cell" [innerHTML]="dataItem[item.field]">
            <span *ngIf="item.type == 0 || item.type == 1" [innerHTML]="dataItem[item.field]"></span>
            <span *ngIf="item.type == 2" [innerHTML]="dataItem[item.field] | date: 'dd-MMM-yyyy'"></span>
            <span *ngIf="item.type == 3" [innerHTML]="dataItem[item.field] | date: 'dd-MMM-yyyy h:mm a'"></span>
            <span *ngIf="item.type == 4" [innerHTML]="dataItem[item.field] | date: 'H:mm'"></span>
          </div>
          <ng-template #normalCell>
            <span *ngIf="item.type == 0 || item.type == 1" [innerHTML]="dataItem[item.field]"></span>
            <span *ngIf="item.type == 2" [innerHTML]="dataItem[item.field] | date: 'dd-MMM-yyyy'"></span>
            <span *ngIf="item.type == 3" [innerHTML]="dataItem[item.field] | date: 'dd-MMM-yyyy h:mm a'"></span>
            <span *ngIf="item.type == 4" [innerHTML]="dataItem[item.field] | date: 'H:mm'"></span>
          </ng-template>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-messages pagerItems=""></kendo-grid-messages>
      <ng-template kendoGridNoRecordsTemplate>
        No record(s) found!
      </ng-template>
    </kendo-grid>
    <div class="pager-wrapper" *ngIf="reportLoaded && dataSource.data.length > 0">
      <kendo-pager [skip]="skip"
                   [pageSize]="pageSize"
                   [pageSizeValues]="false"
                   [total]="dataSource.total"
                   [buttonCount]="5"
                   (pageChange)="onPageChange($event)">
      </kendo-pager>
    </div>
  </div>
<div class="col-12 px-0 mt-4 bg-white d-flex align-items-center justify-content-center" style=" min-height: 250px;" *ngIf="reportLoaded && dataSource.data.length == 0">
  <h3>No data found.</h3>
</div>
<ng-template #tooltiptemplate let-anchor>
  <span>{{ anchor.nativeElement.innerText }}</span>
</ng-template>
